import { MaterialTypeEnum } from "@ns/types";

export const materialTypeMapper = (materialType: MaterialTypeEnum) => {
  switch (materialType) {
    case MaterialTypeEnum.GRANITE:
      return "GRANIT";
    case MaterialTypeEnum.MARBLE:
      return "MERMER";
    case MaterialTypeEnum.ONYX:
      return "ONIKS";
    case MaterialTypeEnum.QUARTZ:
      return "KVARC";
    case MaterialTypeEnum.TRAVERTINE:
      return "TRAVERTIN";
    case MaterialTypeEnum.PESCAR:
      return "PESCAR";
    case MaterialTypeEnum.KERAMIKA:
      return "KERAMIKA";
    case MaterialTypeEnum.VESTAK:
      return "VESTAK";
    case MaterialTypeEnum.KRECNJAK:
      return "KRECNJAK";
    case MaterialTypeEnum.QUARZITE:
      return "KVARCIT";
  }
};

export const materialTypeReverseMapper = (materialType: MaterialTypeEnum) => {
  switch (materialType) {
    case MaterialTypeEnum.GRANITE:
      return "Granit";
    case MaterialTypeEnum.MARBLE:
      return "Mermer";
    case MaterialTypeEnum.ONYX:
      return "Oniks";
    case MaterialTypeEnum.QUARTZ:
      return "Kvarc";
    case MaterialTypeEnum.TRAVERTINE:
      return "Travertin";
    case MaterialTypeEnum.PESCAR:
      return "Pescar";
    case MaterialTypeEnum.KERAMIKA:
      return "Keramika";
    case MaterialTypeEnum.VESTAK:
      return "Vestak";
    case MaterialTypeEnum.KRECNJAK:
      return "Krecnjak";
    case MaterialTypeEnum.QUARZITE:
      return "Kvarcit";
  }
};
